import { render, staticRenderFns } from "./InboundLoadApproval.vue?vue&type=template&id=71bf8c92&"
import script from "./InboundLoadApproval.vue?vue&type=script&lang=js&"
export * from "./InboundLoadApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports